import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import ViewEventLogDetailsForm from './form'

const ViewEventLogDetailsDialog = React.forwardRef(function ViewEventLogDetailsDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (eventLogId) => setDialogState({
      open: true,
      processing: false,
      eventLogId
    })
  }), [setDialogState])

  return (
    <SydModal
      title='Event Log Details'
      open={dialogState.open}
      onClose={close}
      size='medium'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <ViewEventLogDetailsForm
            eventLogId={dialogState.eventLogId}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

ViewEventLogDetailsDialog.propTypes = {
  onComplete: PropTypes.func
}

ViewEventLogDetailsDialog.defaultProps = {
  onComplete: () => {}
}

export default ViewEventLogDetailsDialog
